var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getIsVisible)?_c('v-radio-group',{attrs:{"row":_vm.getIsHorizontal},on:{"change":_vm.emitChangeEvent},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}},_vm._l((_vm.valueItem.items),function(n){return _c('v-radio',{key:n.id,attrs:{"label":n.text,"value":n.id,"dense":""}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }